var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlyIconFacebook = function SvgOnlyIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M36 18a18 18 0 1 0-20.8 17.778V23.209h-4.578v-.018h-.018V18H15.2v-3.968c0-4.505 2.67-7.007 6.785-7.007 1.342.02 2.68.143 4.004.37v.015h.018v4.412h-2.261c-2.225 0-2.948 1.39-2.948 2.818v3.337h4.987v.037h.024l-.797 5.19h-4.195v12.543A17.946 17.946 0 0 0 36 18"
  })));
};
export default SvgOnlyIconFacebook;